export default "__VITE_ASSET__BAhp3$ZE__"